<template>
  <section id="marketing" class="py-24 bg-primary text-white">
    <div class="max-w-7xl mx-auto px-6">
      <div class="text-center mb-16">
        <span
          class="text-brand font-bold tracking-widest text-xs uppercase mb-2 block"
          >Marketing Tools</span
        >
        <h2 class="text-3xl md:text-4xl font-bold">內建行銷神器，提升客單價</h2>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
        <div
          class="p-6 bg-white/5 rounded-2xl border border-white/10 hover:bg-white/10 transition-colors reveal"
        >
          <div class="text-4xl mb-4">⏳</div>
          <h4 class="font-bold text-lg mb-2">限時倒數</h4>
          <p class="text-sm text-gray-400">
            營造活動急迫感，首頁與商品頁皆可配置。
          </p>
        </div>
        <div
          class="p-6 bg-white/5 rounded-2xl border border-white/10 hover:bg-white/10 transition-colors reveal"
        >
          <div class="text-4xl mb-4">🎟️</div>
          <h4 class="font-bold text-lg mb-2">優惠券系統</h4>
          <p class="text-sm text-gray-400">
            支援折扣碼複製、滿額折抵、免運券設定。
          </p>
        </div>
        <div
          class="p-6 bg-white/5 rounded-2xl border border-white/10 hover:bg-white/10 transition-colors reveal"
        >
          <div class="text-4xl mb-4">🎯</div>
          <h4 class="font-bold text-lg mb-2">Meta Pixel 整合</h4>
          <p class="text-sm text-gray-400">
            無痛串接 Facebook
            像素。自動追蹤瀏覽、加入購物車與購買事件，助您精準優化廣告成效。
          </p>
        </div>
        <div
          class="p-6 bg-white/5 rounded-2xl border border-white/10 hover:bg-white/10 transition-colors reveal"
        >
          <div class="text-4xl mb-4">💬</div>
          <h4 class="font-bold text-lg mb-2">線上客服</h4>
          <p class="text-sm text-gray-400">
            懸浮按鈕整合即時通訊工具，對話零距離。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MarketingSection",
};
</script>
